import { BaseTemplateConfig, MenuItemTypeEnum } from "piramis-base-components/src/plugins/AdminTemplate/NewConfig";
import store from "@/store/store";
import { Guid } from "guid-typescript";

export const sidebar: BaseTemplateConfig['sidebar'] = [
  {
    type: MenuItemTypeEnum.Route,
    route: {
      name: 'Users',
    },
    icon: {
      name: 'icon-users',
      iconType: "feather",
    },
  },
  {
    type: MenuItemTypeEnum.DynamicHeader,
    isVisible: [ (ctx) => !!ctx && !!ctx.route.params.networkId ],
    img: (ctx) => store.getters.getCurrentUser(ctx?.route?.params?.id).avatar,
    title: (ctx) => {
      const user = store.getters.getCurrentUser(ctx?.route?.params?.id)

      return user.username ?? user.title
    },
    icon: {
      name: 'icon-database',
      iconType: "feather",
    },
  },
  {
    type: MenuItemTypeEnum.Route,
    isVisible: [
      (ctx) => !!ctx?.route?.params?.id
    ],
    route: {
      name: 'User',
    },
    icon: {
      name: 'icon-user',
      iconType: "feather",
    },
  },
  {
    type: MenuItemTypeEnum.Route,
    isVisible: [
      (ctx) => !!ctx?.route?.params?.id
    ],
    route: {
      name: 'Events',
    },
    icon: {
      name: 'icon-bell',
      iconType: "feather",
    },
  },
  {
    type: MenuItemTypeEnum.Route,
    isVisible: [
      (ctx) => !!ctx?.route?.params?.id
    ],
    route: {
      name: 'Triggers',
    },
    icon: {
      name: 'icon-zap',
      iconType: "feather",
    },
  },
  {
    type: MenuItemTypeEnum.Dropdown,
    guid: Guid.create().toString(),
    isVisible: [ (ctx) => !!ctx?.route?.params?.id ],
    icon: {
      name: 'icon-bar-chart',
      iconType: "feather",
    },
    alias: 'menu_statistics_tab_title',
    children: [
      {
        type: MenuItemTypeEnum.Route,
        isVisible: [
          (ctx) => !!ctx?.route?.params?.id
        ],
        route: {
          name: 'Triggers_statistics',
        },
        icon: {
          name: 'icon-zap',
          iconType: "feather",
        },
      },
      {
        type: MenuItemTypeEnum.Route,
        isVisible: [
          (ctx) => !!ctx?.route?.params?.id
        ],
        route: {
          name: 'Events_statistics',
        },
        icon: {
          name: 'icon-bell',
          iconType: "feather",
        },
      },
    ]
  },
]
